import { render, staticRenderFns } from "./design_rpt.vue?vue&type=template&id=5bc8294a&scoped=true&"
import script from "./design_rpt.vue?vue&type=script&lang=js&"
export * from "./design_rpt.vue?vue&type=script&lang=js&"
import style0 from "./design_rpt.vue?vue&type=style&index=0&id=5bc8294a&scoped=true&lang=less&"
import style1 from "./design_rpt.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc8294a",
  null
  
)

export default component.exports